import BANNER_INTRO_VIDEO_VP8_500K from './media/banner/intro-video-vp8-500k.webm';
import BANNER_INTRO_VIDEO_VP9_500K from './media/banner/intro-video-vp9-500k.webm';
import BANNER_INTRO_VIDEO_X264_1000K from './media/banner/intro-video-x264-1000k.mp4';
import BANNER_INTRO_VIDEO from './media/banner/intro-video.jpg';
import BENEFITS_BACKGROUND from './media/benefits/background.svg';
import BENEFITS_COMMUNITY from './media/benefits/community.svg';
import BENEFITS_DISH from './media/benefits/dish.svg';
import BENEFITS_DISTRIBUTION_CHANCE from './media/benefits/distribution-chance.svg';
import BENEFITS_MONETISATION from './media/benefits/monetisation.svg';
import BENEFITS_VIRAL_ENGINE from './media/benefits/viral-engine.svg';
import BTS_BTS_IMAGE_1X from './media/bts/bts-image@1x.jpg';
import BTS_BTS_IMAGE_2X from './media/bts/bts-image@2x.jpg';
import PARTNERS_DISTRIBUTION_PARTNERS_LOGOS_AUDIBLE from './media/partners/Distribution_Partners_logos_Audible.svg';
import PARTNERS_DISTRIBUTION_PARTNERS_LOGOS_FACEBOOK from './media/partners/Distribution_Partners_logos_Facebook.svg';
import PARTNERS_DISTRIBUTION_PARTNERS_LOGOS_LIFETIME from './media/partners/Distribution_Partners_logos_Lifetime.svg';
import PARTNERS_DISTRIBUTION_PARTNERS_LOGOS_RCTI from './media/partners/Distribution_Partners_logos_RCTI+.png';
import PARTNERS_DISTRIBUTION_PARTNERS_LOGOS_TIKTOK from './media/partners/Distribution_Partners_logos_Tiktok.svg';
import PARTNERS_DISTRIBUTION_PARTNERS_LOGOS_VIDIO from './media/partners/Distribution_Partners_logos_Vidio.svg';
import PARTNERS_DISTRIBUTION_PARTNERS_LOGOS_YOUTUBE from './media/partners/Distribution_Partners_logos_Youtube.svg';
import PARTNERS_DISTRIBUTION_PARTNERS_LOGOS_MAXSTREAM from './media/partners/Distribution_Partners_logos_maxstream.png';
import PARTNERS_ROCK_ENTERTAINMENT from './media/partners/Rock Entertainment.png';
import PARTNERS_AIRASIACOM_LOGO from './media/partners/airasiacom_logo.svg';
import PARTNERS_MEDIACORP_SEEKLOGO_COM_01 from './media/partners/mediacorp-seeklogo.com-01.svg';
import TESTIMONIALS_AGUNG_SENTAUSA from './media/testimonials/agung-sentausa.jpg';
import TESTIMONIALS_DANIEL_YAM from './media/testimonials/daniel-yam.jpg';
import TESTIMONIALS_DIEGO_BATARA_MAHAMERU from './media/testimonials/diego-batara-mahameru.jpg';
import TESTIMONIALS_JONAH_GARCIA from './media/testimonials/jonah-garcia.png';
import TESTIMONIALS_LAURENT_CROUZEIX from './media/testimonials/laurent-crouzeix.png';
import WHY_CLAPPERBOARD from './media/why/clapperboard.svg';
import WHY_GLOBE from './media/why/globe.svg';
import WHY_TROPHY from './media/why/trophy.svg';

export const BannerVideo = {
  video: {
    vp8: BANNER_INTRO_VIDEO_VP8_500K,
    vp9: BANNER_INTRO_VIDEO_VP9_500K,
    x264: BANNER_INTRO_VIDEO_X264_1000K,
  },
  poster: BANNER_INTRO_VIDEO,
};

export const WhyBackground = BENEFITS_BACKGROUND;
export const WhyGraphics = {
  clapperboard: WHY_CLAPPERBOARD,
  globe: WHY_GLOBE,
  trophy: WHY_TROPHY,
};

export const BenefitsGraphics = {
  community: BENEFITS_COMMUNITY,
  dish: BENEFITS_DISH,
  distributionChance: BENEFITS_DISTRIBUTION_CHANCE,
  monetisation: BENEFITS_MONETISATION,
  viralEngine: BENEFITS_VIRAL_ENGINE,
};

export const PartnerImages = {
  media: [
    [
      PARTNERS_DISTRIBUTION_PARTNERS_LOGOS_AUDIBLE,
      PARTNERS_ROCK_ENTERTAINMENT,
      PARTNERS_MEDIACORP_SEEKLOGO_COM_01,
      PARTNERS_DISTRIBUTION_PARTNERS_LOGOS_LIFETIME,
    ],
    [
      PARTNERS_DISTRIBUTION_PARTNERS_LOGOS_VIDIO,
      PARTNERS_DISTRIBUTION_PARTNERS_LOGOS_MAXSTREAM,
      PARTNERS_DISTRIBUTION_PARTNERS_LOGOS_RCTI,
      PARTNERS_AIRASIACOM_LOGO,
    ],
  ],
  social: [
    [
      PARTNERS_DISTRIBUTION_PARTNERS_LOGOS_TIKTOK,
      PARTNERS_DISTRIBUTION_PARTNERS_LOGOS_YOUTUBE,
      PARTNERS_DISTRIBUTION_PARTNERS_LOGOS_FACEBOOK,
    ],
  ],
};

export const CommunityImages = {
  agungSentausa: TESTIMONIALS_AGUNG_SENTAUSA,
  danielYam: TESTIMONIALS_DANIEL_YAM,
  diegoBataraMahameru: TESTIMONIALS_DIEGO_BATARA_MAHAMERU,
  jonahGarcia: TESTIMONIALS_JONAH_GARCIA,
  laurentCrouzeix: TESTIMONIALS_LAURENT_CROUZEIX,
};

export const FooterBackground = {
  default: BTS_BTS_IMAGE_1X,
  I1X: BTS_BTS_IMAGE_1X,
  I2X: BTS_BTS_IMAGE_2X,
};
